import { useQuery } from '@tanstack/react-query';
import { postingsService } from '../postingsService';
import { IGetPostingsParams } from '../types';

interface IUseGetPostingsOptions {
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
}

export const useGetPostings = (
  params: IGetPostingsParams,
  options?: IUseGetPostingsOptions,
) => {
  const { data, error, isFetching, isLoading, isError, refetch } = useQuery({
    queryKey: ['GET_POSTINGS', params],
    queryFn: async () => postingsService.getPostings(params),
    retry: false,
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
    refetch,
  };
};
